import axios from "axios";
import { config } from "./config";

export const coreApi = axios.create({
  baseURL: config.apiBaseUrl,
});

// Separate instance for public endpoints (OAuth, etc) that don't need credentials
export const publicApi = axios.create({
  baseURL: config.apiBaseUrl,
  withCredentials: false,
});

// Interceptor: ensure OAuth endpoints never send credentials (cookies)
// Note: setting the Cookie header directly is a browser-forbidden operation;
// withCredentials=false is the correct way to suppress cookies on cross-origin requests.
coreApi.interceptors.request.use((config) => {
  if (config.url?.includes("/oauth")) {
    config.withCredentials = false;
  }
  return config;
});
